// The refusal signal for the enforcement layer: citadelGate, Citadel.assert
// and Citadel.filterFor all throw it, and the server error middleware maps it
// to the fixed 403 shape. The message is developer-facing — what crosses the
// HTTP boundary is decided by the middleware, never by this class.
export class ForbiddenError extends Error {
	readonly action: string;
	readonly subject: string;

	constructor(action: string, subject: string) {
		super(`Forbidden: ${action} ${subject}`);
		this.name = "ForbiddenError";
		this.action = action;
		this.subject = subject;
	}
}
